import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { BaseService } from '../../services/base.service';
import { PersononboardService } from '../../../person-on-board/services/persononboard.service';
import { ConstantsService } from '../../services/constants.service';
import { MasterRequest, Request } from '../../../person-on-board/model/masterrequest.model';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '../../services/notification.service';

@Component({
  selector: 'ara-pobadd-members',
  templateUrl: './pobadd-members.component.html',
  styleUrls: ['./pobadd-members.component.css']
})
export class PobaddMembersComponent implements OnInit {
  @Input()
  CompanyId: number;
  passrequestId: number;
  sub: any;
  userId: any;
  alertType: string;
  successDetails: string;
  pobMembers: Members;
  pobMembersList: any[];
  passRequestForData: MasterRequest;
  passRequestForFormData: Request;
  passRequests: Request[] = [];
  passRequestList: any;
  passRequestDataForAddMembers: any;
  pobAddMembersDetails: POBAddMembers;
  errorDetails: any;
  confirmMessage: string;
  constructor(private route: ActivatedRoute, private commonService: CommonService, private baseService: BaseService, private pobServices: PersononboardService, private router: Router,
    private translate: TranslateService, private notificationsService: NotificationsService) {
    this.sub = this.route.params.subscribe(params => {
      this.passrequestId = +params['passId'];
    });
    this.passRequestForFormData = new Request();
    this.passRequestForData = new MasterRequest();
    this.pobMembers = new Members();
    this.pobMembersList = [];
    this.passRequestList = [];
    this.pobAddMembersDetails = new POBAddMembers();
  }

  ngOnInit() {
    this.pobMembers = new Members();
    this.pobMembersList.push(this.pobMembers);
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }
  confirmPassRequest() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        PassRequestId: this.passrequestId,
      }
    };
    this.commonService.confirmPassRequest(apiRequest, this.callbackMethodForConfirmPassRequest.bind(this));
  }
  callbackMethodForConfirmPassRequest(response) {
    if (response.Success) {
      if (this.pobMembers.Company !== '' || this.pobMembers.Email !== '') {
        this.addMembers();
      } else {
        this.notificationsService.toastNotify("success", 'Success Message', 'Visit Confirmed successfully');
        this.router.navigate(['pob/pass-request-overview']);
      }
    } else if(response.Errors[0].Message==='There is no row at position 0.'){
      this.notificationsService.toastNotify('error','Error Message','No Such pass exists!!!');
    }
    this.baseService.showRootLoader = false;
  }
  onOkClickedForConfirmation() {
    this.alertType = null;
    this.successDetails = null;
  }
  addMember() {
    this.pobMembers = new Members();
    this.pobMembersList.push(this.pobMembers);
  }
  removeMemberFromList(index) {
    if (this.pobMembersList.length > 1) {
      this.pobMembersList.splice(index, 1);
    }
  }
  saveMemberDetails() {
    this.confirmPassRequest();
  }
  addMembers() {
    this.pobAddMembersDetails.PassRequestId = this.passrequestId;
    this.pobAddMembersDetails.MemberDetails = this.pobMembersList;
    const apiRequest = {
      Model: this.pobAddMembersDetails,
    };
    this.commonService.addPobMembers(apiRequest, this.callbackMethodForAddMembers.bind(this));
  }
  callbackMethodForAddMembers(response) {
    if (response.Success) {
      if (response && response.Success) {
        this.notificationsService.toastNotify("success", "Success Message", 'Members Added successfully');
        this.router.navigate(['pob/pass-request-overview']);
      } else {
        this.alertType = ConstantsService.Error;
        this.errorDetails = response.Error;
      }
      this.baseService.showRootLoader = false;
    }
  }
  onYesClickedForConfirmation() { }
  onNoClickedForConfirmation() { }
  getRemarks(remark,type,index){
    switch (type) {
      case 'PersonName':
        this.pobMembersList[index].PersonName = remark;
        break;
      case 'Email':
          this.pobMembersList[index].Email = remark;
          break;
      case 'Company':
        this.pobMembersList[index].Company = remark;
        break;
      case 'Id':
        this.pobMembersList[index].Id = remark;
        break;
      default:
        break;
    }
  }
}
export class Members {
  public PersonName: string = '';
  public Email: string = '';
  public Company: string = '';
  public Id: string = '';
}
export class POBAddMembers {
  public PassRequestId: number;
  public MemberDetails: Members[];
}
